import { fetchV1 } from 'helpers/fetch.js';
import { toQueryString } from 'helpers/api.js';

export default {
  getRecentEntities(filter) {
    return fetchV1.get(`/recent_entities?${toQueryString(filter)}`);
  },
};
